import { EntityErrorBanner } from '@pesto/features/src/EntityProfile/components/EntityErrorBanner';
import { useListQuery } from '@pesto/hooks';
import { LoadingSpinner } from '@pesto/ui';
import { SmartTable } from '@pesto/ui/features/SmartTable/SmartTable';
import { useNavigate } from 'react-router-dom';

import { useListCardsQuery } from '../../__generated__/graphql/api';
import { routes } from '../../constants/routes';
import { useProgramFilterFields } from '../../hooks/useProgramFilterFields';
import { useCardsListConfig } from './hooks/useCardsListConfig';
import { toCardListItem, type CardListItem } from './toCardListItem';

export const Cards = () => {
  const navigate = useNavigate();

  const { data, loadingOrReFetching, error } = useListQuery({
    queryHook: useListCardsQuery,
  });

  const { programFilterFields, programsLoading } = useProgramFilterFields();
  const { filterFields, getColumns, initialTableState } = useCardsListConfig(programFilterFields);

  const rows: CardListItem[] = (data?.listCards?.cards ?? []).map(toCardListItem);
  const totalRecords = data?.listCards?.pagination?.totalRecords;
  const totalPages = data?.listCards?.pagination?.totalPages;

  const handleRowClicked = (row: CardListItem) => {
    navigate(routes.cards + '/' + row.id);
  };

  return (
    <main className="flex flex-1 flex-col gap-4 p-4 md:p-8">
      {error && <EntityErrorBanner message="We couldn't load cards." detail={error.message} />}
      {programsLoading ? (
        <LoadingSpinner />
      ) : (
        <SmartTable
          title="Cards"
          amountOfRows={totalRecords}
          rows={rows}
          columns={getColumns(handleRowClicked)}
          filterFields={filterFields}
          loading={loadingOrReFetching}
          pageCount={totalPages}
          initialState={initialTableState}
          enableDateRangeFilter
        />
      )}
    </main>
  );
};
